import React, {useState, useRef} from 'react';
import PropTypes from 'prop-types';
import {GatsbyImage} from 'gatsby-plugin-image';
import * as styles from '../Styles/homepage.module.scss';
import ReactPlayer from 'react-player';
import {navigate} from 'gatsby';
import {ctaClickAction} from '../../Application/Shared/TrackActionService';

/**
  *
  * @return {*} CourseVideoPreviewHomePage
  */
function CourseVideoPreviewHomePage({courseImage, previewVideo,
  signupLink, courseSlug, currentPlayingVideo, setCurrentPlayingVideo}) {
  const [showSignupButton, setShowSignupButton] = useState(false);
  const [playing, setPlaying] = useState(true);
  const playerContainerRef = useRef<any>(null);

  const loadLessonPreview = () => {
    setCurrentPlayingVideo(courseSlug);
    ctaClickAction({
      'cta': 'Play Video',
      'action': 'Course Preview',
      'pageKind': 'WebsiteHomePage',
    });
  };

  const onProgressHandler = (e) => {
    if (e.playedSeconds > 300) {
      setPlaying(false);
      setShowSignupButton(true);
      const reactPlayer =
        playerContainerRef.current.querySelector('.reactPlayer');
      reactPlayer.style.opacity = 0.4;
      reactPlayer.style.pointerEvents = 'none';
    }
  };

  const navigateToSignupPage = () => {
    navigate(signupLink);
    ctaClickAction({
      'cta': 'Continue Watching',
      'action': 'Signup',
      'pageKind': 'WebsiteHomePage',
    });
  };

  return (
    currentPlayingVideo !== courseSlug ?
      <div className={styles.popularCardImg}>
        {courseImage && (
          <GatsbyImage
            image={courseImage}
            className={styles.previewImg}
            alt={courseSlug} />
        )}
        <button
          onClick={loadLessonPreview}
          className={styles.playPreviewBtn}
          aria-label="Play">
          <span className='library-brand-icon-new'>
            <i className='icon-new-Play1'></i>
          </span>
        </button>
      </div> :
      courseSlug === currentPlayingVideo && (
        <div ref={playerContainerRef} className={styles.previewVideoContainer}>
          <ReactPlayer
            width='100%'
            height='100%'
            url={previewVideo}
            playing={playing}
            controls={true}
            onProgress={onProgressHandler}
            className="reactPlayer"
            progressInterval={5000}
          />
          {showSignupButton &&
            <button onClick={navigateToSignupPage}
              className={styles.signupCta}>
          Continue Watching
            </button>
          }
        </div>)
  );
}

CourseVideoPreviewHomePage.propTypes = {
  courseImage: PropTypes.object,
  previewVideo: PropTypes.string,
  signupLink: PropTypes.string,
  courseSlug: PropTypes.string,
  currentPlayingVideo: PropTypes.any,
  setCurrentPlayingVideo: PropTypes.func,
};

export default CourseVideoPreviewHomePage;
